import PageNotFound from '../assets/svg/404.svg'
import { useNotFoundStyles } from '../styles/muiStyles';
import { Button, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import NEUniteLogo from '../assets/svg/Logo.svg'


const NotFound = () => {
  const classes= useNotFoundStyles();
  const history = useHistory();
  const handleBack = () => {
    history.push('/');
  }
  return (
    <div>
      <div style={{display:'flex',alignItems:'center',}}>
        <img src={NEUniteLogo} alt="logo" style ={{width:'5vw', height:'5vw', margin:'1.5vw'}} />
        <Typography variant='h6' style={{color:'white',textShadow: '2px 2px #7a7878', letterSpacing:'.3vw'}}>
              <strong> <i>NEUMeet</i></strong>
        </Typography>
      </div>
      <div className = {classes.root} >
        <div>
          <img src={PageNotFound} alt="Not Found" />
        </div>
        <div>
          <Typography variant='h6' style ={{marginTop:'1vw', textAlign:'center',textShadow: '2px 2px #000', letterSpacing:'.3vw'}}>
            <strong> <i>WE ARE SORRY!</i></strong>
          </Typography>
          <Typography variant='h6' style ={{marginBottom:'2vw',textShadow: '2px 2px #000', letterSpacing:'.3vw'}}>
            <strong>BUT THE PAGE YOU REQUESTED WAS NOT FOUND</strong>
          </Typography>
        </div>
        <div>
          <Button
            color="secondary"
            variant="contained"
            size="large"
            onClick={handleBack}>
            GO TO HOMEPAGE
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
